export const CONSTANTS_MESSAGE = {
    TYPE_ERROR: 'error',
    TYPE_SUCCESS: 'success',
    TYPE_INFO: 'info',
    TYPE_WARNING: 'warning',

    DEFAULT_MESSAGE_ERROR: 'DEFAULT_MESSAGE_ERROR',
};